import axios from "axios";

const isLive =
  window?.location?.hostname === "preview.cometchat.com";

const CHAT_BUILDER_PUBLIC_API_URL = isLive
  ? "https://apivcb.cc-cluster-2.io/v1"
  : "https://apivcb.cometchat-staging.com/v1";

interface CreateBuilderPayload {
  templateId?: string;
  name?: string;
  settings?: Record<string, any>;
}

interface UpdateBuilderPayload {
  builderId: string;
  name?: string;
  settings?: Record<string, any>;
}

export async function createTemporaryBuilder(payload: CreateBuilderPayload) {
  const { templateId, settings, name } = payload;

  if (!templateId && (!settings || Object.keys(settings).length === 0)) {
    throw new Error("Both templateId and settings cannot be empty.");
  }

  try {
    const response = await axios.post(
      `${CHAT_BUILDER_PUBLIC_API_URL}/builders`,
      {
        templateId: templateId,
        name: name || "Preview Builder",
      }
    );

    return response.data;
  } catch (error: any) {
    console.error(
      "Error creating temporary builder:",
      error.response?.data || error.message
    );
    throw error;
  }
}

export async function getTemporaryBuilder(builderId: string) {
  if (!builderId) {
    throw new Error("builderId is required.");
  }

  try {
    const response = await axios.get(
      `${CHAT_BUILDER_PUBLIC_API_URL}/builders/${builderId}`
    );
    return response.data;
  } catch (error: any) {
    console.error(
      "Error fetching temporary builder:",
      error.response?.data || error.message
    );
    throw error;
  }
}

export async function updateTemporaryBuilder(payload: UpdateBuilderPayload) {
  const { builderId, settings } = payload;

  if (!builderId) {
    throw new Error("builderId is required to update builder.");
  }

  if (!settings || Object.keys(settings).length === 0) {
    throw new Error("Settings must be provided.");
  }

  try {
    const response = await axios.put(
      `${CHAT_BUILDER_PUBLIC_API_URL}/builders/${builderId}`,
      {
        settings,
      }
    );
    return response.data;
  } catch (error: any) {
    console.error(
      "Error updating temporary builder:",
      error.response?.data || error.message
    );
    throw error;
  }
}
